/**
 * The change list shown before Save / Start (S8 Task 8.11): owner / owning-group changes, every added, removed and
 * changed entry and every EFFECTIVE permission change (the mask applied), widened ones marked — in sentences since UI/UX
 * fix round A (`aclChangeSentences`, U28). `note` = "Other paths may differ" for the Propagate root preview.
 */
import { aclChangeSentences, type AclChangeSide } from '../aclChangeSentences';

type Props = { before: AclChangeSide; after: AclChangeSide; displayNames?: Record<string, string>; title: string; note?: string; testId?: string };

export function AclChangePreview({ before, after, displayNames, title, note, testId = 'hns-acl-preview' }: Props) {
  const lines = aclChangeSentences(before, after, displayNames);
  return (
    <div className="grid gap-1 rounded border border-border bg-muted/30 p-2 text-xs" data-testid={testId}>
      <span className="font-medium">{title}</span>
      {lines.length === 0 ? <span className="text-muted-foreground">No changes.</span> : (
        <ul className="grid gap-0.5">
          {lines.map((line) => <li key={line.text} className={line.widened ? 'text-warning' : undefined} data-widened={line.widened || undefined}>{line.text}</li>)}
        </ul>
      )}
      {note && <span className="text-muted-foreground">{note}</span>}
    </div>
  );
}
